import React from 'react';
import styles from './about-section.module.scss';
import { useTranslation } from 'next-i18next';
import mainStyles from '../../../pages/investors/investors.module.scss';
import { combineCN } from '@helpers/styles.helper';

const InvestorsAboutSection = () => {
	const { t } = useTranslation();

	return (
		<section className={combineCN(mainStyles.main_section_wrapper, styles.about_section)}>
			<h2 className={mainStyles.title}>{t('about_anghami')}</h2>
			<div className={styles.description}>
				{t('landing_about_whoweare_desc')}&nbsp;{t('landing_about_whoweare_desc2')}
			</div>
		</section>
	);
};

export default InvestorsAboutSection;
